import { ChatbotDatasource } from "@core/data/datasources/chatbot.datasource";
import type { FallbackError } from "@core/domain/errors/fallback.error.ts";
import type { ChatbotMessages } from "@core/domain/models/chatbot-message.model";
import type { ChatbotRepository } from "@core/domain/repositories/chatbot.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class ChatbotImplRepository implements ChatbotRepository {
    constructor(
        @inject(ChatbotDatasource)
        private readonly chatbotDatasource: ChatbotDatasource,
    ) {}

    getChatbotMessages(): ResultAsync<ChatbotMessages, FallbackError> {
        return this.chatbotDatasource.getChatbotMessages();
    }

    getWeeklyReport(): ResultAsync<ChatbotMessages, FallbackError> {
        return this.chatbotDatasource.getWeeklyReport();
    }

    sendMessage(message: string): ResultAsync<ChatbotMessages, FallbackError> {
        return this.chatbotDatasource.sendMessage(message);
    }

    deleteMessages(): ResultAsync<true, FallbackError> {
        return this.chatbotDatasource.deleteMessages();
    }
}
